/* eslint-disable eqeqeq */
import React, { useCallback, useEffect, useRef, useState } from "react";
import Table from "../components/Table";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { apiKey } from "../config/config";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useReactToPrint } from "react-to-print";
import PartialPayment from "../components/PartialPayment";

const NoteCell = ({ row, token, lang }) => {
  const [val, setVal] = useState(row.row.original.notes || "");
  const [saving, setSaving] = useState(false);
  const txRef = useRef();

  const adjustHeight = () => {
    if (txRef.current) {
      txRef.current.style.height = "auto";
      txRef.current.style.height = txRef.current.scrollHeight + "px";
    }
  };

  useEffect(() => {
    adjustHeight();
  }, [val]);

  const handleBlurOrSave = () => {
    const currentVal = val || "";
    const originalVal = row.row.original.notes || "";
    if (currentVal.trim() === originalVal.trim()) return;

    setSaving(true);
    axios
      .put(
        `${apiKey}/update-contract-notes/${row.row.original.id}`,
        { notes: currentVal },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(() => {
        row.row.original.notes = currentVal;
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setSaving(false);
      });
  };

  return (
    <div className="position-relative">
      <textarea
        ref={txRef}
        rows={1}
        className="form-control form-control-sm"
        style={{ minWidth: "180px", resize: "none", overflowY: "hidden" }}
        value={val}
        placeholder={lang.add_note || "Add note..."}
        onChange={(e) => setVal(e.target.value)}
        onBlur={handleBlurOrSave}
        onKeyDown={(e) => {
          if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            handleBlurOrSave();
            e.target.blur();
          }
        }}
      />
      {saving && (
        <span
          className="position-absolute top-50 translate-middle-y end-0 me-2 spinner-border spinner-border-sm text-primary"
          style={{ width: "12px", height: "12px", border: "2px solid currentColor", borderRightColor: "transparent" }}
        ></span>
      )}
    </div>
  );
};
// import DatePicker from "react-multi-date-picker";
// import arabic from "react-date-object/calendars/arabic";
// import arabic_ar from "react-date-object/locales/arabic_ar";

export default function ValidCon({ lang }) {
  const token = JSON.parse(sessionStorage.getItem("aman-admin") || "null")
    ?.admin
    ? JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).token
    : null;

  const user = JSON.parse(
    JSON.parse(sessionStorage.getItem("aman-admin"))?.admin || "{}"
  );
  const userRole = user?.role;

  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const [contractList, setContractList] = useState([]);
  const [contractData, setContractData] = useState({
    id: "",
    total_value: "",
    total_paid: "",
    final_installment: "",
  });
  const [branchId, setBranchId] = useState();
  const [paymentMethod, setPaymentMethod] = useState();
  const [payment, setPayment] = useState();
  const [note, setNote] = useState();
  const [discount, setDiscount] = useState();
  const [receipts, setReceipts] = useState([]);
  const [receiptData, setReceiptData] = useState({
    FullName: "",
    Address: "",
    MobilePhoneNo: "",
    Email: "",
    branch_name: "",
    branch_location: "",
    contact_number: "",
    email: "",
    date: "",
    reference_number: "",
    amount: "",
    paymentMethod: "",
  });
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  function convertDateFormat(inputDate) {
    const dateObject = new Date(inputDate);
    const options = { day: "2-digit", month: "2-digit", year: "numeric" };

    // const locale = lang.Lang === "en" ? "en-US" : "ar-SA";
    const locale = "en-GB";

    const formattedDate = dateObject.toLocaleDateString(locale, options);
    return formattedDate;
  }

  const handlePayment = () => {
    setLoading(true);
    axios
      .put(
        apiKey + "/get-contract-to-update/" + contractData.id,
        {
          payment: payment,
          discount,
          paymentMethod,
          note,
          user_id: contractData.customer_id,
          branch_id: branchId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((res) => {
        document.getElementById("closePaymentModalButton")?.click();
        if (res.data.contract && res.data.contract[0].status == 2) {
          navigate(`complete-contract/${res.data.contract[0].id}`);
          window.location.reload();
        } else {
          fetchContractInfo(contractData.id, paymentMethod, true);
        }
        fetchContracts();
        toast.success(res.data.Message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
      .catch((err) => {
        console.error(err);
        toast.error("Error Occured", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }).finally(() => setLoading(false));
  };

  const fetchContracts = useCallback(() => {
    try {
      axios
        .get(apiKey + "/get-contracts", {
          params: {
            branch_id: branchId,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setContractList(res.data.result);
        })
        .catch((err) => {
          console.error(err);
        });
    } catch (err) {
      console.error(err);
    }
  }, [branchId, token]);

  const fetchReceipts = (id) => {
    try {
      axios
        .get(apiKey + "/get-receipts/" + id, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setReceipts(res.data.result);
        })
        .catch((err) => {
          console.error(err);
        });
    } catch (err) {
      console.error(err);
    }
  };

  const handleCancelContract = (id) => {
    if (window.confirm(lang.confirm_cancel || "Are you sure you want to cancel this contract?")) {
      setLoading(true);
      axios
        .delete(`${apiKey}/cancel-installment-contract/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          toast.success(res.data.Message || "Contract cancelled successfully", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          fetchContracts();
        })
        .catch((err) => {
          console.error(err);
          toast.error(err.response?.data?.Error || "Error cancelling contract", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        })
        .finally(() => setLoading(false));
    }
  };

  const columns = [
    {
      header: lang.Clients || "Clients",
      accessorKey: "customer_name",
    },
    {
      header: lang.Identity_Number || "Identity Number",
      accessorKey: "customer_validID",
    },
    {
      header: lang.Mobile_Number || "Mobile Number",
      accessorKey: "customer_mobile",
    },
    {
      header: lang.Total || "Total",
      accessorKey: "total_value",
      cell: (row) => row.row.original.total_value - row.row.original.legal_fees,
    },
    // {
    //   header: lang.legal_fees || "Legal Fees",
    //   accessorKey: "legal_fees",
    // },
    // {
    //   header: lang.Amount || "Amount",
    //   cell: (row) => (
    //     // <p>{row.row.original.total_value - row.row.original.profit}</p>
    //     <p>{row.row.original.total_value - row.row.original.legal_fees}</p>
    //   ),
    // },
    // {
    //   header: lang.Quantity || "Quantity",
    //   accessorKey: "quantity",
    // },
    // {
    //   header: lang.Profit || "Profit",
    //   accessorKey: "profit",
    // },
    // {
    //   header: lang.legal_fees || "Legal Fees",
    //   accessorKey: "legal_fees",
    // },
    // {
    //   header: lang.Total || "Total",
    //   accessorKey: "total_value",
    //   cell: (row) => row.row.original.total_value,
    // },
    {
      header: lang.Paid_Up || "Paid up",
      accessorKey: "total_paid",
    },
    {
      header: lang.Residual || "Residual",
      cell: (row) => (
        <p>{row.row.original.total_value - row.row.original.total_paid - row.row.original.legal_fees}</p>
      ),
    },
    {
      header: lang.due_date || "Due Date",
      accessorKey: "due_date",
      cell: (row) => convertDateFormat(row.getValue()),
    },
    {
      header: lang.Status || "Status",
      accessorKey: "status",
      cell: (row) => (
        <p
          className={`badge rounded-pill ${row.getValue() == 1
              ? "bg-success"
              : row.getValue() == 2
                ? "bg-primary"
                : row.getValue() == 3
                  ? "bg-danger"
                  : ""
            }`}
        >
          {row.getValue() == 1
            ? lang.in_progress || "in-progress"
            : row.getValue() == 2
              ? lang.completed || "Completed"
              : row.getValue() == 3
                ? lang.defaulted || "Defaulted"
                : ""}
        </p>
      ),
    },
    {
      header: lang.Note || "Note",
      accessorKey: "notes",
      cell: (row) => <NoteCell row={row} token={token} lang={lang} />,
    },
    // {
    //   header: lang.payment_status || "Payment Status",
    //   accessorKey: "payment_status",
    //   cell: (row) => (
    //     <p
    //       className={`badge rounded-pill ${row.getValue() == 1
    //           ? "bg-warning"
    //           : row.getValue() == 2
    //             ? "bg-success"
    //             : row.getValue() == 3
    //               ? "bg-primary"
    //               : ""
    //         }`}
    //     >
    //       {row.getValue() == 1
    //         ? lang.pending || "Pending"
    //         : row.getValue() == 2
    //           ? lang.due || "Due"
    //           : row.getValue() == 3
    //             ? lang.completed || "Completed"
    //             : ""}
    //     </p>
    //   ),
    // },
    {
      header: lang.Actions || "Actions",
      cell: (row) => (
        <div className="dropdown top-0 start-0">
          <button
            className="btn btn-primary dropdown-toggle"
            type="button"
            id="dropdownMenuButton1"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {lang.Actions || "Actions"}
          </button>
          <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <li>
              <button
                data-bs-toggle="modal"
                data-bs-target="#Comodity"
                type="button"
                onClick={() => setContractData(row.row.original)}
                className="dropdown-item mt-0"
              >
                {lang.add_payment || "Add Payment"}
              </button>
            </li>
            <li>
              <button
                data-bs-toggle="modal"
                data-bs-target="#myModal"
                type="button"
                className="dropdown-item mt-0"
                onClick={(e) => {
                  e.preventDefault();
                  fetchReceipts(row.row.original.id);
                }}
              >
                {lang.view_payment || "View Payments"}
              </button>
            </li>
            {row.row.original.is_editable === 1 && (userRole === "dealer" || userRole === "super") && (
              <li>
                <button
                  type="button"
                  onClick={() => navigate(`edit/${row.row.original.id}`)}
                  className="dropdown-item mt-0"
                // disabled={row.row.original.status != 2}
                >
                  {lang.edit || "Edit"}
                </button>
              </li>
            )}
            {row.row.original.is_editable === 1 && (userRole === "dealer" || userRole === "super") && (
              <li>
                <button
                  type="button"
                  onClick={() => handleCancelContract(row.row.original.id)}
                  className="dropdown-item mt-0 text-danger"
                >
                  {lang.cancel_contract || "Cancel Contract"}
                </button>
              </li>
            )}
          </ul>
        </div>
      ),
    },
  ];

  const fetchContractInfo = (id, paymentMethod, openModal = false) => {
    axios
      .get(`${apiKey}/get-complete-contract/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setReceiptData({ ...res.data.result[0], paymentMethod });
        if (openModal) {
          document.getElementById("openReceiptModalButton")?.click();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    try {
      if (branchId) {
        fetchContracts();
      }
    } catch (err) {
      console.error(err);
    }
  }, [branchId, fetchContracts]);

  useEffect(() => {
    setPayment(
      contractData.final_installment <
        contractData.total_value - contractData.total_paid - (discount || 0)
        ? contractData.final_installment
        : contractData.total_value - contractData.total_paid - (discount || 0),
    );
  }, [contractData, discount]);

  useEffect(() => {
    setDiscount(contractData.discount || 0);
  }, [contractData]);

  useEffect(() => {
    setBranchId(
      JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).branch_id,
    );
  }, []);
  return (
    <div>
      <main id="main" className="main">
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <div className="pagetitle">
          <h1>{lang.General_Management || "General Management"}</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                >
                  <path d="m21.743 12.331-9-10c-.379-.422-1.107-.422-1.486 0l-9 10a.998.998 0 0 0-.17 1.076c.16.361.518.593.913.593h2v7a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-4h4v4a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .743-1.669z"></path>
                </svg>
              </li>
              <li className="breadcrumb-item">
                {lang.General_Management || "General Management"}
              </li>
              <li className="breadcrumb-item active">
                {lang.Valid_Contract || "Valid Contract"}
              </li>
            </ol>
          </nav>
        </div>

        <section className="section">
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <div className="row pt-3 pb-3">
                    <div className="rr col-9">
                      {lang.List_of_Valid_Contracts || "List Of Valid Contract"}
                    </div>
                  </div>

                  <div classNames="d-flex mt-3 mb-3">
                    <Table lang data={contractList} columns={columns} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* add payment */}
        <div className="modal fade" id="Comodity" tabindex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    handlePayment();
                  }}
                >
                  <div className="row mb-2 mt-5 d-flex justify-content-center">
                    <div className="col-sm-8  mb-3">
                      <label htmlFor="" className="w-100">
                        <span style={{ fontSize: "14px" }}>
                          {lang.Total_Value || "Total Value"}
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          value={contractData.total_value}
                          required
                        />
                      </label>
                    </div>
                  </div>
                  <div className="row mb-2 d-flex justify-content-center">
                    <div className="col-sm-8  mb-3">
                      <label htmlFor="" className="w-100">
                        <span style={{ fontSize: "14px" }}>
                          {lang.Remaining || "Remaining"}
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          value={
                            contractData.total_value - contractData.total_paid
                          }
                          required
                        />
                      </label>
                    </div>
                  </div>
                  <div className="row mb-2 d-flex justify-content-center">
                    <div className="col-sm-8  mb-3">
                      <label htmlFor="" className="w-100">
                        <span style={{ fontSize: "14px" }}>
                          {lang.legal_fees || "Legal Fees"}
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          value={contractData.legal_fees}
                          required
                        />
                      </label>
                    </div>
                  </div>
                  <div className="row mb-2 d-flex justify-content-center">
                    <div className="col-sm-8  mb-3">
                      <label htmlFor="" className="w-100">
                        <span style={{ fontSize: "14px" }}>
                          {lang["Additional Discount"] || "Additional Discount"}
                        </span>
                        <input
                          type="number"
                          className="form-control"
                          value={discount}
                          onChange={(e) => setDiscount(e.target.value)}
                          required
                        />
                      </label>
                    </div>
                  </div>
                  <div className="row mb-2 d-flex justify-content-center">
                    <div className="col-sm-8  mb-3">
                      <label htmlFor="" className="w-100">
                        <span style={{ fontSize: "14px" }}>
                          {lang.Remaining || "Remaining"}
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          value={
                            contractData.total_value -
                            contractData.total_paid -
                            (discount || 0)
                          }
                          required
                        />
                      </label>
                    </div>
                  </div>
                  <div className="row mb-2 d-flex justify-content-center">
                    <div className="col-sm-8  mb-3">
                      <label htmlFor="" className="w-100">
                        <span style={{ fontSize: "14px" }}>
                          {lang.payment || "Payment"}
                        </span>
                        <input
                          type="number"
                          className="form-control"
                          max={
                            contractData.total_value - contractData.total_paid
                          }
                          value={payment}
                          onChange={(e) => setPayment(e.target.value)}
                          required
                        />
                      </label>
                    </div>
                  </div>
                  <div className="row mb-2 d-flex justify-content-center">
                    <div className="col-sm-8  mb-3">
                      <label htmlFor="" className="w-100">
                        <span style={{ fontSize: "14px" }}>
                          {lang.payment_method || "Payment Method"}
                        </span>
                        <select
                          onChange={(e) => setPaymentMethod(e.target.value)}
                          className="form-control"
                          name=""
                          id=""
                          required
                        >
                          <option value="" disabled selected></option>
                          <option value="Cash">{lang.cash || "Cash"}</option>
                          <option value="Bank Transfer">
                            {lang.bank_transfer || "Bank Transfer"}
                          </option>
                          <option value="Card">{lang.card || "Card"}</option>
                        </select>
                      </label>
                    </div>
                  </div>
                  <div className="row mb-2 d-flex justify-content-center">
                    <div className="col-sm-8  mb-3">
                      <label htmlFor="" className="w-100">
                        <span style={{ fontSize: "14px" }}>
                          {lang.Note || "Note"}
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          value={note}
                          onChange={(e) => setNote(e.target.value)}
                        />
                      </label>
                    </div>
                  </div>
                  <div className="text-center mb-5">
                    <button
                      id="closePaymentModalButton"
                      type="button"
                      className="btn-save"
                      data-bs-dismiss="modal"
                    >
                      {lang.Cancel || "Cancel"}
                    </button>
                    <button disabled={loading} type="submit" className="btn-cancel ms-4">
                      {lang.Add_Now || "Add Now"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Payments */}
        <div className="modal fade in" id="myModal" tabindex="-1">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title" id="myModalLabel">
                  {lang.view_payment || "View Payments"}
                </h4>
                <button
                  type="button"
                  className="close"
                  data-bs-toggle="modal"
                  data-bs-target="#myModal"
                >
                  <i className="fa fa-2x">×</i>
                </button>
              </div>
              <div className="modal-body">
                <div className="table-responsive">
                  <table
                    id="CompTable"
                    className="table table-bordered table-hover table-striped"
                  >
                    <thead>
                      <tr>
                        <th style={{ width: "30%" }}>{lang.date || "Date"}</th>
                        <th style={{ width: "30%" }}>
                          {lang.reference_no || "Reference No"}
                        </th>
                        <th style={{ width: "15%" }}>
                          {lang.Amount || "Amount"}
                        </th>
                        <th style={{ width: "15%" }}>
                          {lang.paid_by || "Paid by"}
                        </th>
                        <th style={{ width: "10%" }}>
                          {lang.Actions || "Actions"}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {receipts.map((receipt, index) => (
                        <tr className="row1" key={index}>
                          <td>{convertDateFormat(receipt.date)}</td>
                          <td>{receipt.reference_number}</td>
                          <td>{receipt.amount}</td>
                          <td>{receipt.payment_method}</td>
                          <td>
                            <div className="text-center">
                              <button
                                className="btn btn-primary"
                                type="button"
                                data-bs-toggle="modal"
                                data-bs-target="#myModal1"
                                onClick={(e) => {
                                  e.preventDefault();
                                  fetchContractInfo(
                                    receipt.contract_id,
                                    receipt.payment_method,
                                  );
                                }}
                              >
                                {lang.receipt || "Receipt"}
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button
          id="openReceiptModalButton"
          style={{ display: "none" }}
          data-bs-toggle="modal"
          data-bs-target="#myModal1"
        ></button>
        {/* Reciepts */}
        <div className="modal fade in" id="myModal1" tabindex="-1">
          <div
            className="modal-content modal-dialog"
            style={{
              maxWidth: "80%",
            }}
          >
            <div className="modal-body print position-relative">
              <button
                type="button"
                className="close"
                data-bs-toggle="modal"
                data-bs-target="#myModal1"
              >
                <i className="fa fa-2x">×</i>
              </button>
              <button
                type="button"
                // onClick={() => toPDF()}
                onClick={handlePrint}
                className="btn btn-primary position-absolute top-0 end-0"
                style={{ margin: "1rem 1rem" }}
              >
                {lang.print_reciept || "Print Receipt"}
              </button>
              {receiptData && <PartialPayment contractData={receiptData} />}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
